/**
 * The footer the shared pages end with - the legal pages in src/shared/views (impressum, agb, datenschutz).
 *
 * Each app provides its own under PAGE_FOOTER, once, in its main.js: LIQUIDO its liquido-footer with the team and
 * polls icons. Polly provides none, so its legal pages simply end - they are reached from a link and left with
 * the browser's Back button.
 */
export const PAGE_FOOTER = Symbol("pageFooter")
